<template>
  <div id="app">
    <div v-if="!isMobileMode" class="pc-container">
      <!-- 顶部菜单栏 -->
      <div class="topBar" v-if="!$route.meta.hideMenu" ref="topbar">
        <top-menu-bar />
      </div>

      <!-- 页面内容 -->
      <main
        ref="main"
        :class="!$route.meta.hideMenu ? 'main-content' : 'loginPage'"
        v-if="!showSecondary"
        :style="{ marginTop: !$route.meta.topCss ? '0px' : '65px' }"
      >
        <router-view />
      </main>
      <secondary-container v-else />
      <foot-bar v-if="!$route.meta.hideMenu" />
      <!-- <div class="foot-bar" v-if="!$route.meta.hideMenu"></div> -->
    </div>
    <router-view v-else />
    <!-- <div
      v-else
      class="mobile-container"
      :class="{ 'mobile-container-nofooter': $route.meta.hideMenu }"
    >
      <router-view />
      <login-tip v-if="!isLogin" />
      <mobile-footer v-if="!$route.meta.hideMenu" />
    </div> -->
  </div>
</template>

<script>
import TopMenuBar from "@/components/menuBar/menuBar.vue";
import footBar from "@/components/footer/footBar.vue";
import mobileFooter from "@/components/mobile/Footer.vue";
import SecondaryContainer from "@/components/SecondaryPageContainer/SecondaryPageContainer.vue";
import LoginTip from "@/components/mobile/LoginTip.vue";
import { mapActions, mapGetters } from "vuex";
import { paramConfig } from "./api/modules/base";

export default {
  name: "App",
  data() {
    return {
      // isSecondaryPageOpen: false,
    };
  },
  async mounted() {
    this.listenTopBar();
    this.listenResize();
    // this.setIsMobileMode();
    // this.listenExit();
    await this.getParamConfig();
    const accountInfo = localStorage.getItem("accountInfo");
    if (accountInfo) {
      this.setUserInfo(JSON.parse(accountInfo));
    }
    if (this.shouldAutoDingTalkAuth()) {
      this.setIsMobileModeReady(true);
      this.$router.replace({
        path: "/h5/dingtalk-auth",
        query: { redirect: this.$route.fullPath },
      });
      return;
    }
    if (
      this.$store.state.app.isMobileMode &&
      this.isWeChatBrowser() &&
      window.location.pathname !== "/loginLoading"
    ) {
      this.wxshouquan();
    }
  },
  methods: {
    ...mapActions("app", ["setIsMobileMode", "setIsMobileModeReady"]),
    ...mapActions("user", ["setUserInfo"]),
    listenExit() {},
    // exit(event) {
    //   if (performance.getEntriesByType("navigation")[0].type === "navigate") {
    //     localStorage.removeItem("accountInfo");
    //     this.setUserInfo(null);
    //   }
    // },
    wxshouquan() {
      this.$store.dispatch("user/wxauthorization");
    },
    isWeChatBrowser() {
      // 获取 User-Agent 并转为小写（避免大小写问题）
      const userAgent = navigator.userAgent.toLowerCase();
      // 检测是否包含微信核心标识
      return /micromessenger|wechat/.test(userAgent);
    },
    isDingTalkBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /dingtalk/.test(userAgent);
    },
    shouldAutoDingTalkAuth() {
      if (!this.$store.state.app.isMobileMode) {
        return false;
      }
      if (!this.isDingTalkBrowser()) {
        return false;
      }
      if (localStorage.getItem("accountInfo")) {
        return false;
      }
      if (this.$route.query?.skipDingTalkAuth === "1") {
        return false;
      }
      if (sessionStorage.getItem("dingtalkAuthFailed") === "1") {
        return false;
      }
      if (
        this.$route.path === "/h5/dingtalk-auth" ||
        this.$route.path === "/loginLoading"
      ) {
        return false;
      }
      return this.$route.path.startsWith("/h5");
    },
    async getParamConfig() {
      try {
        const res = await paramConfig();
        localStorage.setItem("allConfig", JSON.stringify(res));
      } catch (error) {
        console.error("获取公钥失败:", error);
      }
    },
    listenResize() {
      window.addEventListener("resize", () => {
        this.setIsMobileMode();
      });
    },
    listenTopBar() {
      const topbar = this.$refs.topbar;
      if (!topbar) return;
      document.addEventListener("scroll", function () {
        // 获取滚动距离（像素）
        const scrollTop =
          document.pageYOffset || document.documentElement.scrollTop;

        // 根据滚动距离计算背景透明度（0到1之间）
        // 这里设置滚动到300px时完全变色，可根据需求调整
        const opacity = Math.min(scrollTop / 300, 1);

        // 根据透明度设置背景颜色
        // 可以是固定颜色加透明度，也可以是渐变色
        topbar.style.backgroundColor = `rgba(255, 255, 255, ${opacity})`;
        if (scrollTop > 300) {
          topbar.style.boxShadow = `0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)`;
        } else {
          topbar.style.boxShadow = "none";
        }
      });
    },
  },

  components: {
    TopMenuBar,
    footBar,
    SecondaryContainer,
    mobileFooter,
    LoginTip,
  },
  computed: {
    ...mapGetters("app", ["isMobileMode"]),
    ...mapGetters("user", ["info"]),

    showSecondary() {
      return this.$store.state.page.showSecondary;
    },
    isSecondaryPageOpen() {
      return this.$store.state.secondaryPageVisible;
    },
  },
  watch: {
    isMobileMode(newVal) {
      // if (newVal) {
      //   window.location.href = "http://uia.cfec.edu.cn/h5/";
      // }
    },
    $route() {
      // this.$store.commit("setSecondaryPageVisible", false);
    },
  },
};
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #eff3fc;
  font-family: "Microsoft YaHei", sans-serif;
  /* padding: 0; */
}

.pc-container {
  /* height: 100vh; */
}
.mobile-container {
  height: calc(100vh - 56px);
  margin-bottom: 56px;
  background-color: #fff;
}
.mobile-container-nofooter {
  margin-bottom: 0px !important;
  height: 100vh;
}

.main-content {
  flex: 1;
  padding: 0px;
}

.foot-bar {
  flex-shrink: 0; /* 禁止收缩 */
  margin-top: 30px;
}
.loginPage {
  height: 100vh;
}
.topBar {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
}
/* .topBar1{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
} */
@media screen and (max-width: 1366px) {
  /* 调整弹窗整体宽度 */
  .el-message-box {
    width: 90% !important;
    max-width: 300px !important;
  }
}
</style>
